// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactUs_contact__210ZC","social":"ContactUs_social__1Fnkm"};